import React from 'react';
import cinemabox from '../assets/images/cinemabox.png';
import cohm from '../assets/images/cohm.png';
import primer from '../assets/images/primer.png';
import sapy from '../assets/images/sapy.png';
import '../assets/styles/Project.scss';

function Project() {
  const projects = [
    {
      title: 'Sapy - Free Shardeum Node Rewards & APY Calculator',
      url: 'https://sapy.nguro.com/',
      name: 'Sapy',
      cover: sapy,
      description:
        'Sapy is a modern web application designed to help cryptocurrency enthusiasts calculate potential earnings from running Shardeum blockchain nodes. The platform provides real-time APY calculations, ROI analysis, and profitability projections for different node types including validators, archivers, and standby nodes.Built with an intuitive interface featuring interactive sliders and dynamic charts, Sapy transforms complex blockchain economics into an accessible user experience. Users can adjust parameters like initial investment, operating costs, and reward rates to see instant visual feedback on their potential returns and investment timelines. The application was developed as part of a community initiative to make node investment decisions more transparent and data-driven within the Shardeum ecosystem.',
    },
    {
      title: 'Cinemabox – Free Online Movie and Tv Shows Streaming',
      url: 'https://www.cinemabox.site/',
      name: 'Cinemabox',
      cover: cinemabox,
      description:
        'A seamless and high-performance movie streaming platform, using TypeScript and React. The app features a sleek, responsive UI powered by Tailwind CSS and PostCSS, ensuring an optimized viewing experience across devices. It integrates TMDB for dynamic movie data, while Redux Toolkit and Redux Saga handle state management and async operations efficiently. TanStack Router enables smooth client-side navigation, and Axios facilitates fast, reliable API requests. With a focus on performance, scalability, and user experience, Cinemabox delivers free, on-demand streaming with an intuitive and engaging interface.',
    },
    {
      title: 'City of Hope Ministries – Empowering Lives Through Faith',
      url: 'https://main.d3rz9ql594465v.amplifyapp.com/',
      name: 'City of Hope Ministries',
      cover: cohm,
      description:
        "The official website for City of Hope Ministries, Wakiso, providing a modern, user-friendly platform for the church's community engagement. Built with TypeScript and React, the site features a clean and responsive design using Tailwind CSS, PostCSS, and Material UI for an elegant and accessible interface. Redux Toolkit and Redux Saga efficiently manage state, ensuring smooth interactions, while TanStack Router enables seamless navigation. Axios powers fast and secure API communication, delivering real-time updates on events, donations, and church activities. This platform serves as a digital hub, connecting the ministry with its congregation and outreach initiatives.",
    },
    {
      title: 'Primer – Smart Notes & Task Management',
      url: 'https://github.com/francis-Paul-code/primer',
      name: 'Primer',
      cover: primer,
      description:
        'A simple note-taking and task management app using Angular 13 and TypeScript to help users stay organized and productive. The app features a clean, responsive UI with dynamic components, seamless state management, and intuitive task categorization. With real-time syncing, reminders, and a rich text editor, Primer enables efficient note organization and task prioritization. Designed for speed and usability, the app ensures a smooth experience, whether managing daily to-dos or long-term projects.',
    },
  ];

  return (
    <div className="projects-container" id="projects">
      <h1>Personal Projects</h1>
      <div className="projects-grid">
        {projects.map((project, idx) => (
          <div className="project" key={idx}>
            <a href={project.url} target="_blank" rel="noreferrer">
              <img
                src={project.cover}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </a>
            <a href={project.url} target="_blank" rel="noreferrer">
              <h2>{project.title}</h2>
            </a>
            <p>{project.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Project;
